import React, { useEffect, useState } from "react";
import {
  ActionBarPpsItemDokumenComp,
  CreatePpsDokumenComp,
  DatatablePpsItemDokumen,
  ItemDokumenPpsComp,
  Base64ViewerComp,
} from "../../components/moleculs";
import axios from "../../library/axios";
import { useParams } from "react-router-dom";
import { Modal } from "react-bootstrap";
import { MySwal } from "../../library/swal";
import {
  IconArrowLeft,
  IconSquareRoundedPlus,
  // IconRefresh,
} from "@tabler/icons-react";
import { useLocation } from "react-router-dom";
import { validationAccess } from "../../helpers/validationAccess"
import { LoadingAtom } from "../../components/atoms";
import { getModule, setHrefWithSlugHook, useNavigateWithSlugHook, } from "../../../src/config/routes/guards/slug";
import { getSlug, } from "../../../src/config/routes/guards/slug";

const PpsItemDokumenPage = () => {
  const baseUrl = new URL(window.location.href);
  const routeParams = useParams();
  // console.log(routeParams.idRekomendasi)
  const location = useLocation();
  const segments = location.pathname.split('/').filter(Boolean);

  const navigate = useNavigateWithSlugHook();
  const [search, setSearch] = useState([]);
  const [filterData, setFilterData] = useState([]);
  const [itemPps, setitemPps] = useState({});
  const [itemDokumenPps, setitemDokumenPps] = useState([]);
  const [listItemPps, setListItemPps] = useState([]);
  const [lgShowAdd, setLgShowAdd] = useState(false);
  const [disabledBtnSync, setDisabledBtnSync] = useState(false);
  const [loadingData, setloadingData] = useState(true);
  const [loadingShowFrame, setLoadingShowFrame] = useState(false);
  const [lgShowIframe, setLgShowIframe] = useState(false);
  const [base64String, setbase64String] = useState("");
  const [link, setLink] = useState("");
  const [role, setRole] = useState("");

  const [isPdf, setisPdf] = useState("application/pdf");

  const handleChangePage = () => {
    setHrefWithSlugHook(`/pps-item/${routeParams.idRekomendasi}`);
  };

  const fetchItemPps = async () => {
    try {
      const options = {
        url: `/pps-item/param-id-item-pps/${routeParams.id}`,
        method: "GET",
        headers: {
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
        },
      };
      const { data } = await axios(options);
      // console.log(data.data);
      setitemPps(data?.data);
    } catch (err) {
      console.log(err.message);
    }
  };

  const fetchItemDokumenPps = async () => {
    try {
      const options = {
        url: `/pps-item/param-dokumen-id-pps/${routeParams.id}`,
        method: "GET",
        headers: {
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
        },
      };
      const { data } = await axios(options);
      // console.log(data.data);
      setTimeout(() => {
        setloadingData(false);
      }, 1000);
      setitemDokumenPps(data?.data);
      setListItemPps(data?.data);
    } catch (err) {
      setloadingData(false);
      console.log(err.message);
    }
  };

  const handleHapus = (id) => {
    MySwal.fire({
      title: "Apa anda yakin menghapus data ini?",
      text: "Anda tidak akan dapat mengembalikan data ini!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Ya, Hapus Data!",
      cancelButtonText: "Batal",
    }).then((result) => {
      if (result.isConfirmed) {
        const config = {
          headers: {
            Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
          },
        };

        axios
          .delete(`/pps-item/dokumen-pps/${id}`, config)
          .then((res) => {
            // console.log(res)
            // return false
            if (res.status === 200) {
              MySwal.fire({
                icon: "success",
                title: "Success",
                text: "Hapus Dokumen Item PPS Berhasil!",
              });
              // return false
              setTimeout(() => {
                fetchItemDokumenPps();
              }, 3000);
            }
          })
          .catch((err) => {
            if (err !== "") {
              console.log(err?.response?.data);
              // err({ err: err?.response?.data || err });
            }
          });
      }
    });
  };

  const fetchOneUser = async () => {
    try {
      const options = {
        url: `/users/detailUser`,
        method: "GET",
        headers: {
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
        },
      };
      const { data } = await axios(options);
      setRole(data?.data?.mapping_user_groups[0]?.group?.namaGroup);
    } catch (err) {
      console.log(err.message);
    }
  };

  useEffect(() => {
    validatedItemPps()
  }, []);

  const validatedItemPps = () => {

    const requestBody = {
      idItemPps: routeParams.id,
    };

    axios({
      url: "/pps-item/validate-doc-pps",
      method: "POST",
      data: requestBody,
      headers: { Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}` },
    })
      .then((res) => {
        // console.log(res.status)
        // return false
        if (res.status === 200) {
          fetchOneUser();
          fetchItemPps();
          fetchItemDokumenPps();
          fetchLoginStatus();
        } else {
          MySwal.fire({
            icon: "error",
            title: "Oops, Error!",
            text: `${res?.message}`,
          });
        }
      })
      .catch((err) => {
        if (err !== "") {
          console.log(err?.response?.data?.message);
          MySwal.fire({
            icon: "error",
            title: "Oops, Error!",
            text: `${err?.response?.data?.message}`,
          });
        }
      });
  };

  const handleChangeSearch = (text) => {
    setSearch(text);
  };

  useEffect(() => {
    const result = itemDokumenPps?.filter((item) => {
      let nama_dokumen = item.nama_dokumen;

      return nama_dokumen.toLowerCase().match(search.toString().toLowerCase());
    });
    setListItemPps(result);
  }, [search]);
  // console.log(search);

  // const downloadFile = (base64String, fileName) => {
  //   const mimeType = base64String.split(";")[0].split(":")[1];

  //   // if (base64String.substring(0, 20) === isPdf) {
  //   //   var mimeType = "application/pdf";
  //   // }

  //   const b64Data = base64String.replace(/^[^,]+,/, "");
  //   const byteCharacters = atob(b64Data);
  //   const byteNumbers = new Array(byteCharacters.length);

  //   for (let i = 0; i < byteCharacters.length; i++) {
  //     byteNumbers[i] = byteCharacters.charCodeAt(i);
  //   }

  //   const byteArray = new Uint8Array(byteNumbers);
  //   const blob = new Blob([byteArray], { type: mimeType });

  //   const url = URL.createObjectURL(blob);

  //   const link = document.createElement("a");
  //   link.href = url;
  //   link.setAttribute("download", fileName);
  //   document.body.appendChild(link);

  //   link.click();

  //   document.body.removeChild(link);
  // };

  const downloadFile = (url, fileName) => {
    const concatUrl = baseUrl.origin.concat(`/${url}`);
    const link = document.createElement("a");
    link.href = concatUrl;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);

    link.click();

    document.body.removeChild(link);
  };

  const viewBase64File = async (id) => {
    try {
      setLink("");
      setLoadingShowFrame(true);
      const options = {
        url: `/pps-item/show/${id}`,
        method: "GET",
        headers: {
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
        },
      };
      const { data } = await axios(options);
      setLoadingShowFrame(false);
      // console.log(data.data.dokumen);
      // return false;
      if (data.data.mimeType !== isPdf) {
        downloadFile(data.data.link, data.data.nama_dokumen);
        return false;
      }
      const concatUrl = baseUrl.origin.concat(`/${data.data.link}`);
      setLgShowIframe(true);
      setLink(concatUrl);
    } catch (err) {
      setLoadingShowFrame(false);
      console.log(err.message);
    }
  };

  // const handleSyncDocPps = () => {
  //   const requestBody = {
  //     idItemPps: routeParams.id,
  //   };

  //   axios({
  //     url: "/pps-item/syncDocPpsToOnline",
  //     method: "POST",
  //     data: requestBody,
  //     headers: { Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}` },
  //   })
  //     .then((res) => {
  //       // console.log(res);
  //       // return false;
  //       if (res.status === 200) {
  //         fetchItemDokumenPps();
  //         MySwal.fire({
  //           icon: "success",
  //           title: "Success",
  //           text: `${res?.data?.message}`,
  //         });
  //       }
  //     })
  //     .catch((err) => {
  //       if (err !== "") {
  //         console.log(err?.response?.data?.message);
  //         MySwal.fire({
  //           icon: "error",
  //           title: "Oops, Error!",
  //           text: `${err?.response?.data?.message}`,
  //         });
  //       }
  //     });
  // };

  const handleSyncOneDocPps = (id) => {
    MySwal.fire({
      title: "Apa anda yakin ?",
      text: "Dokumen PPS ini akan di sinkron ke SPEAK Online.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Ya, Lanjutkan!",
      cancelButtonText: "Batal",
    }).then((result) => {
      if (result.isConfirmed) {
        setDisabledBtnSync(true);
        const requestBody = {
          idDocumentPps: id,
        };

        axios({
          url: "/pps-item/syncOneDocPpsToOnline",
          method: "POST",
          data: requestBody,
          headers: { Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}` },
        })
          .then((res) => {
            // console.log(res.status);
            // return false;
            if (res.status === 200) {
              fetchItemDokumenPps();
              MySwal.fire({
                icon: "success",
                title: "Success",
                text: `${res?.data?.message}`,
              });
              setDisabledBtnSync(false);
            }
          })
          .catch((err) => {
            if (err !== "") {
              console.log(err?.response?.data?.message);
              MySwal.fire({
                icon: "error",
                title: "Oops, Error!",
                text: `${err?.response?.data?.message}`,
              });
              setDisabledBtnSync(false);
            }
          });
      }
    });
  };

  const fetchLoginStatus = async () => {
    // console.log(id)
    // return false
    try {
      await validationAccess(getModule())
      const options = {
        url: `/users/detailUser`,
        method: "GET",
        headers: {
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
        },
      };
      const { data } = await axios(options);
      // console.log(data)
      if (data.login === false) {
        MySwal.fire({
          icon: "info",
          title: "Oops, Unauthorize!",
          text: "Session anda habis, Silahkan login kembali.",
        });

        setTimeout(() => {
          localStorage.removeItem(`token${getSlug() ? '-' + getSlug() : ''}`);
          localStorage.clear();
          setHrefWithSlugHook("/login");
        }, 3000);
      } else {
        // console.log(data?.data?.mapping_groups[0].module.pathModule)
        let check = data?.data?.mapping_groups?.some(
          (mp) => location.pathname == mp?.module?.pathModule
        );

        if (check === false) {
          MySwal.fire({
            icon: "info",
            title: "Oops, No Access!",
            text: "Anda tidak memiliki akses di halaman ini.",
          });

          setTimeout(() => {
            localStorage.removeItem(`token${getSlug() ? '-' + getSlug() : ''}`);
            setHrefWithSlugHook("/login");
          }, 3000);
        }
      }
    } catch (err) {
      console.log(err.message);
    }
  };

  return (
    <>
      {/*begin::Content*/}
      <div
        className="content d-flex flex-column flex-column-fluid"
        id="kt_content"
      >
        {/*begin::Toolbar*/}
        <div className="toolbar" id="kt_toolbar">
          {/*begin::Container*/}
          <div
            id="kt_toolbar_container"
            className="container-fluid d-flex flex-stack"
          >
            {/*begin::Page title*/}
            <div
              data-kt-swapper="true"
              data-kt-swapper-mode="prepend"
              data-kt-swapper-parent="{default: '#kt_content_container', 'lg': '#kt_toolbar_container'}"
              className="page-title d-flex align-items-center flex-wrap me-3 mb-5 mb-lg-0"
            >
              {/*begin::Title*/}
              <h1 className="d-flex align-items-center text-dark fw-bolder fs-3 my-1">
                Perencanaan Perbaikan Strategis (PPS)
                {/*begin::Separator*/}
                <span className="h-20px border-gray-200 border-start ms-3 mx-2" />
                {/*end::Separator*/}
                {/*begin::Description*/}
                <small className="text-muted fs-7 fw-bold my-1 ms-1">
                  #SPEAK_VERSI_RS
                </small>
                {/*end::Description*/}
              </h1>
              {/*end::Title*/}
            </div>
            {/*end::Page title*/}
            {/*begin::Actions*/}
            {/* <ActionBarPpsItemDokumenComp
              showFormAdd={() => setLgShowAdd(true)}
            /> */}
            {/*end::Actions*/}
          </div>
          {/*end::Container*/}
        </div>
        {/*end::Toolbar*/}
        {/*begin::Post*/}
        <div className="post d-flex flex-column-fluid" id="kt_post">
          {/*begin::Container*/}
          <div id="kt_content_container" className="container-xxl">
            {/*begin::Row*/}
            <div className="row gy-5 g-xl-8">
              {/*begin::Col*/}
              <div className="col-xl-12">
                <div className="card">
                  <div className="card-body">
                    <div className="d-flex justify-content-between mb-5">
                      <div>
                        <h5 className="card-title mb-5">
                          Daftar Dokumen Item PPS
                        </h5>
                      </div>
                      <div>
                        {loadingData === true ? (
                          ""
                        ) : (
                          <>
                            {role === "Kelompok Kerja" ||
                              role === "Surveior Internal" ? (
                              <a
                                onClick={() => setLgShowAdd(true)}
                                className="btn btn-sm btn-primary"
                              >
                                <IconSquareRoundedPlus stroke={2} /> Tambah
                                Dokumen Perbaikan
                              </a>
                            ) : (
                              ""
                            )}
                            &nbsp;
                            <button
                              onClick={() => handleChangePage()}
                              className="btn btn-sm btn-info"
                            >
                              <IconArrowLeft stroke={2} /> Kembali
                            </button>
                          </>
                        )}

                        {/* &nbsp;
                        <button
                          onClick={() => handleSyncDocPps()}
                          className="btn btn-sm btn-danger"
                        >
                          <IconRefresh stroke={2} /> Sync Dokumen PPS
                        </button> */}
                      </div>
                    </div>
                    {loadingData === true ? (
                      <LoadingAtom />
                    ) : (
                      <>
                        <ItemDokumenPpsComp itemsdokumen={itemPps} />
                        <DatatablePpsItemDokumen
                          listdokumen={listItemPps}
                          search={search}
                          role={role}
                          handleChangeSearch={handleChangeSearch}
                          handleHapus={handleHapus}
                          downloadFile={downloadFile}
                          viewBase64File={viewBase64File}
                          syncOneDocPps={handleSyncOneDocPps}
                          disabledBtnSync={disabledBtnSync}
                          loadingShowFrame={loadingShowFrame}
                        />
                        {lgShowIframe === true ? (
                          <Base64ViewerComp
                            link={link}
                            close={() => setLgShowIframe(false)}
                          />
                        ) : (
                          ""
                        )}
                      </>
                    )}
                  </div>
                </div>
              </div>
              {/*end::Col*/}
            </div>
            {/*end::Row*/}
          </div>
          {/*end::Container*/}
        </div>
        {/*end::Post*/}
      </div>
      {/*end::Content*/}

      <Modal
        show={lgShowAdd}
        onHide={() => setLgShowAdd(false)}
        backdrop="static"
        keyboard={false}
        size="md"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <b>Form Laporan Perencanaan Perbaikan Strategis</b>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <CreatePpsDokumenComp
            close={() => setLgShowAdd(false)}
            fetch={() => fetchItemDokumenPps()}
            listdokumen={listItemPps}
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

export default PpsItemDokumenPage;
